import { Directive, AfterViewInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ShopSettingsService } from '../services/shop-settings.service';

@Directive({
  selector: '[appTouchKeyboard]'
})
export class SelectFirstInputDirective implements AfterViewInit {

  constructor(
    private shopSettingsService: ShopSettingsService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  ngAfterViewInit() {
    if (!this.shopSettingsService.isVUMode || !this.document) {
      return;
    }

    const formChildren = [].slice.call(this.document.children);
    const input = formChildren[0].querySelector('[appTouchKeyboard]');
    if (input && this.document.activeElement !== input) {
      // input.style.backgroundColor = 'yellow';
      input.focus();
    }
  }
}
